import { useEffect, useState } from 'react';
import { fetchBlobUrl } from '../api';

/**
 * An image behind the App's bearer auth. The browser cannot put an
 * Authorization header on an <img> tag, so the bytes are fetched and handed
 * over as a blob URL, revoked when the component goes away.
 */
export function AuthImage({ path, alt, className }: {
  path: string; alt: string; className?: string;
}) {
  const [url, setUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let revoked = false;
    let current: string | null = null;
    setUrl(null);
    setFailed(false);
    fetchBlobUrl(path)
      .then((blobUrl) => {
        if (revoked) { URL.revokeObjectURL(blobUrl); return; }
        current = blobUrl;
        setUrl(blobUrl);
      })
      .catch(() => setFailed(true));
    return () => {
      revoked = true;
      if (current) URL.revokeObjectURL(current);
    };
  }, [path]);

  if (failed) {
    return (
      <div className={`flex items-center justify-center bg-paper-200 text-xs text-ink-500 dark:bg-ink-700 dark:text-ink-400 ${className ?? ''}`}>
        Photograph unavailable
      </div>
    );
  }
  if (!url) {
    return <div className={`animate-pulse bg-paper-200 dark:bg-ink-700 ${className ?? ''}`} />;
  }
  return <img src={url} alt={alt} className={className} />;
}
